"use client";

import {Toaster as Comp, toast} from "sonner";

function Toaster({...props}: React.ComponentProps<typeof Comp>) {
  return (
    <Comp
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "flex items-center gap-2 w-full rounded-md bg-popover text-primary text-sm p-3 shadow-popover",
          title: "font-semibold",
          description: "text-xs text-primary/70",
        },
      }}
      {...props}
    />
  );
}

export {Toaster, toast};
